<template>

	<div id="knd-blok6" class="knd-blok">
		<div class="knd-blok-content">
			<div class="knd-blok-titel" v-html='getContent(stap, "Tussenkop")'></div>
			<div class="knd-blok-tekst" v-html='getContent(stap, "Tekst")'></div>
		</div>

		<div class="knd-blok-foto-wrapper">
			<img 
				class="knd-blok-foto" 
				:src='require("@/assets/images/tiktok_strooi1.png")' />
		</div>
	</div>
		
</template>

<script>

export default {
	name: 'Blok6',
	props: ['stap', 'language', 'mobiel'],
	methods: {
		getContent(content, label) {
			if (this.language === "nl") {
				return content[label].data;
			}
			else {
				return content[label].data5891;	
			}
		}

	}
}
</script>
